import { graphql } from 'gatsby';
import { FluidObject } from 'gatsby-image';
import React, { FC } from 'react';
import styled from 'styled-components';
import { RemoteWorkQuery } from '../../../graphql-types';
import { PageForm } from '../../components/Form';
import { Card, CardImg, CardsGridWrap, Count, Title } from '../../components/ItemsGrid';
import { Layout, PageHero, Section } from '../../components/Layout';
import { RemoteWorkers } from '../../components/RemoteWorkers';
import SEO from '../../components/SEO';
import { Strong } from '../../components/Strong';
import { floralwhite } from '../../utils/styles';

const TopicDetails = styled.div`
  p:nth-child(4) {
    margin: 0;
  }
`;

type RemoteWorkGearProps = {
  data: RemoteWorkQuery;
};

const RemoteWorkGear: FC<RemoteWorkGearProps> = ({ data }) => {
  return (
    <Layout>
      <SEO title="Remote Work - Gear" />
      <PageHero
        image={<RemoteWorkers />}
        content={
          <TopicDetails>
            <h1>
              Are you happy with your home <Strong>office setup</Strong>?
            </h1>
            <p>
              From the comfort of our office chairs we’ve created this list with everything you need to work from home
              and make your back feel great.
            </p>
            <p>Bonus: since it’s Black Friday, you can expect to find discounts for most of the items.</p>
            <p>Don’t shop too much and enjoy!</p>
          </TopicDetails>
        }
      />
      <Section>
        <CardsGridWrap>
          {data.categories.edges.map(({ node }) => {
            const category = node.data;
            const [localFile] = category?.picture?.localFiles || [];
            const pictureFluid = localFile?.childImageSharp?.fluid;
            return (
              category && (
                <Card key={node.id} to={`/remote-work/gear/${category.slug}`}>
                  {pictureFluid && <CardImg fluid={pictureFluid as FluidObject} />}
                  <Title>{category.name}</Title>
                  <Count>
                    <Strong>{category.gearItems?.length}</Strong> products
                  </Count>
                </Card>
              )
            );
          })}
        </CardsGridWrap>
      </Section>
      <Section color={floralwhite}>
        <PageForm
          endpoint="topic"
          cta="get advice"
          title="What’s keeping you up at night?"
          subtitle="Whatever that is, there are experienced people who figured it out. We find them and share their lessons with you."
          fields={[
            {
              name: 'topic',
              label: 'I want to',
              type: 'text',
              initialValue: '',
              placeholder: 'Make a wish...',
            },
            {
              name: 'email',
              label: 'Send all the advice to',
              type: 'email',
              initialValue: '',
              placeholder: 'Type your email here...',
            },
          ]}
        />
      </Section>
    </Layout>
  );
};

export default RemoteWorkGear;

export const pageQuery = graphql`
  query RemoteWorkGearsGears {
    categories: allAirtableRemoteWorkGearCategories(sort: { fields: data___weight, order: ASC }) {
      totalCount
      edges {
        node {
          id
          data {
            name
            slug
            weight
            gearItems {
              id
            }
            picture {
              localFiles {
                childImageSharp {
                  fluid(maxWidth: 150) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
